var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.95c0-1.342 1.108-2.45 2.5-2.45s2.5 1.108 2.5 2.45V10h-5V7.95zM8 10.063V7.95C8 5.757 9.802 4 12 4s4 1.757 4 3.95v2.113A2 2 0 0117.5 12v5.5a2 2 0 01-2 2h-7a2 2 0 01-2-2V12A2 2 0 018 10.063zM8 12a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v5.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12z",
    fill: "currentColor"
  })));
}

export default SvgLockFill;